import { normalizeDate, getTimeZone } from 'client/griffin'
import { getJSONFromScript } from 'lib/server_params'

function dateFormatValidator(field, message) {
  return values => {
    if (!(values[field] instanceof Date)) {
      if (!values[field]) {
        return {}
      }

      const dateObj = normalizeDate(values[field], {
        timeZone: getTimeZone(),
        style: 'yMMdd',
      })

      if (dateObj.errors) {
        return { [field]: [message] }
      }
      return {}
    }

    if (isNaN(values[field].valueOf())) {
      return { [field]: [message] }
    }
    return {}
  }
}

export function maxDaysValidator(
  fieldName,
  start = new Date(),
  maxDays,
  message
) {
  return values => {
    const START_DATE_BUFFER = 1
    const dateInQuestion = values[fieldName]
    const maxTime = (START_DATE_BUFFER + maxDays) * 86400000
    // if it's not a date, user is probably still typing, so ignore that
    if (!(dateInQuestion instanceof Date)) {
      return {}
    }

    if (dateInQuestion.getTime() - start.getTime() > maxTime) {
      return { [fieldName]: [message] }
    }
    return {}
  }
}

export function endDateValidators(fieldName, message) {
  let validators = []

  let deviceInfo = getJSONFromScript('store').device_info
  if (!deviceInfo.isMobile) {
    validators.push(dateFormatValidator(fieldName, message))
  }

  return validators
}
